import styled, { keyframes } from 'styled-components';
import { media } from '../../common/MediaQueries';

const flash = keyframes`
  0%, 100% {
    opacity: 0.6;
  }

  50% {
    opacity: 1;
  }
`;

export const JobCurrentCandidatesLoading = styled.span`
  will-change: opacity;
  animation: ${flash} 2s linear infinite;
  width: 10rem;
  height: 1.3rem;
  display: inline-block;
  border-radius: 6px;
  background-color: rgba(101, 138, 200, 0.2);
`;

export const JobCurrentCandidatesWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  margin-top: 3px;
  min-height: 38px;
`;
